<template>
  <default-modal :open="open" @close="close" maxWidthClass="max-w-6xl">
    <template v-if="clip" slot="header">
      {{ clip.title }}
    </template>
    <div slot="body" class="py-6 px-6">
      <div class="flex">
        <div
          class="relative overflow-hidden w-2/3 md:pr-8"
          style="padding-top: 37.5%;"
        >
          <iframe
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
            :src="embedUrl"
            frameborder="0>"
            scrolling="no>"
            allowfullscreen="true"
          >
          </iframe>
        </div>
        <div class="w-1/3 md:pl-8 text-left" v-if="clip">
          <div class="border border-gray-200 p-4 rounded mb-4">
            <dl>
              <div class=" sm:grid sm:grid-cols-3 sm:gap-4">
                <dt class="text-sm leading-5 font-medium text-gray-500">
                  Date
                </dt>
                <dd
                  class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                >
                  {{ clip.date | date_dmyhm }}
                </dd>
              </div>
              <div class="sm:grid sm:grid-cols-3 sm:gap-4 mt-2" v-if="game">
                <dt class="text-sm leading-5 font-medium text-gray-500">
                  Jeu
                </dt>
                <dd
                  class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                >
                  {{ game.name }}
                </dd>
              </div>
              <div class="sm:grid sm:grid-cols-3 sm:gap-4 mt-2">
                <dt class="text-sm leading-5 font-medium text-gray-500">
                  Créateur
                </dt>
                <dd
                  class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                >
                  {{ clip.creator_name }}
                </dd>
              </div>
              <div class="sm:grid sm:grid-cols-3 sm:gap-4 mt-2">
                <dt class="text-sm leading-5 font-medium text-gray-500">
                  Durée
                </dt>
                <dd
                  class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
                >
                  {{ clip.duration }} secondes
                </dd>
              </div>
            </dl>
          </div>
          <div class="border border-gray-200 p-4 rounded">
            <label
              for="project_id"
              class="block text-sm font-medium leading-5 text-gray-700"
            >
              Projet
            </label>
            <div class="mt-1 rounded-md shadow-sm">
              <select
                v-model="project_id"
                id="project_id"
                class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              >
                <option
                  v-for="project in notClipProjects"
                  :key="project.id"
                  :value="project.id"
                  >{{ project.title }}</option
                >
              </select>
            </div>
            <div class="mt-2">
              <button
                @click="addToProject"
                class="w-full py-1.5 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 shadow-sm hover:bg-indigo-500 focus:outline-none focus:shadow-outline-blue active:bg-indigo-600 transition duration-150 ease-in-out"
              >
                Ajouter
              </button>
            </div>
            <div class="mt-2">
              <div
                class="flex justify-between hover:bg-gray-50 py-1 cursor-default px-1"
                v-for="project in clipProjects"
                :key="project.id"
              >
                <span class="self-center text-gray-600 text-sm">{{
                  project.title
                }}</span>
                <button
                  @click="detach(project)"
                  type="button"
                  class="inline-flex items-center px-2 py-1.5 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-500 hover:bg-red-400 focus:outline-none focus:border-red-700 focus:shadow-outline-red active:bg-red-700 transition ease-in-out duration-150"
                >
                  <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fill-rule="evenodd"
                      d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="border border-gray-200 p-4 rounded mt-4">
            <a
              v-if="clip.video_with_offset"
              target="_blank"
              :href="clip.video_with_offset"
              class="w-full mr-2 py-1.5 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 shadow-sm hover:bg-indigo-500 hover:text-white focus:outline-none focus:shadow-outline-blue active:bg-indigo-600 transition duration-150 ease-in-out"
            >
              Voir replay
            </a>
            <a
              :href="clip.download_url"
              class="w-full py-1.5 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 shadow-sm hover:bg-indigo-500 hover:text-white focus:outline-none focus:shadow-outline-blue active:bg-indigo-600 transition duration-150 ease-in-out"
            >
              Télécharger
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse px-6 pb-4"
    >
      <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button
          @click="close"
          type="button"
          class="inline-flex justify-center w-full rounded-md border border-gray-300 px-16 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
          Fermer
        </button>
      </span>
    </div>
  </default-modal>
</template>

<script>
import { mapState } from "vuex";
import DefaultModal from "@/components/global/modals/DefaultModal";
export default {
    components: {
        DefaultModal
    },
    data() {
        return {
            errors: [],
            project_id: null
        };
    },
    props: {
        open: {
            type: Boolean,
            required: true
        },
        clip: {
            type: Object,
            required: false
        }
    },
    computed: {
        ...mapState("project", ["projects"]),
        ...mapState("game", ["games"]),
        embedUrl() {
            return this.clip
                ? `https://clips.twitch.tv/embed?clip=${this.clip.twitch_id}`
                : null;
        },
        hasProjects() {
            return this.projects.length > 0;
        },
        selectedProject() {
            return this.project_id
                ? this.projects.filter(project => {
                    return this.project_id === project.id;
                })[0]
                : null;
        },
        game() {
            const filter = this.games.filter(game => {
                return game.id === this.clip.game_id;
            });
            return filter.length > 0 ? filter[0] : null;
        },
        clipProjects() {
            return this.projects.filter(project => {
                return (
                    project.clips.filter(clip => {
                        return clip.id === this.clip.id;
                    }).length > 0
                );
            });
        },
        notClipProjects() {
            return this.projects.filter(project => {
                return !this.clipProjects
                    .map(p => {
                        return p.id;
                    })
                    .includes(project.id);
            });
        }
    },
    methods: {
        close() {
            this.$emit("close");
        },
        clearErrors() {
            this.errors = [];
        },
        addToProject() {
            this.$store
                .dispatch("project/clipStore", {
                    project_id: this.project_id,
                    clip_id: this.clip.id
                })
                .then(res => {
                    if (res.status === 200) {
                        this.close();
                        this.clearErrors();
                        const toast = {
                            type: "success",
                            title: `Clip ajouté au projet ${this.selectedProject.title}`,
                            content: `Retrouvez tous les clips de ce projet en cliquant <a href='/projects/${this.selectedProject.public_id}'>ici</a>`
                        };
                        this.$store.dispatch("notification/addToast", toast);
                    } else {
                        let err = [];
                        Object.values(res.response.data.errors).forEach(er => {
                            err = [...err, ...er];
                        });
                        this.errors = err;
                    }
                })
                .catch(err => {
                    if (err.response.status === 400) {
                        const toast = {
                            type: "error",
                            title: `Clip appartenant déjà au projet ${this.selectedProject.title}`,
                            content: `Retrouvez tous les clips de ce projet en cliquant <a href='/projects/${this.selectedProject.public_id}'>ici</a>`
                        };
                        this.$store.dispatch("notification/addToast", toast);
                    }
                });
        },
        detach(project) {
            this.$store
                .dispatch("project/clipDelete", {
                    project_id: project.id,
                    clip_id: this.clip.id
                })
                .then(res => {
                    if (res.status === 200) {
                        this.clearErrors();
                        const toast = {
                            type: "success",
                            title: `Clip supprimé du projet ${project.title}`,
                            content: `Retrouvez tous les clips de ce projet en cliquant <a href='/projects/${project.public_id}'>ici</a>`
                        };
                        this.$store.dispatch("notification/addToast", toast);
                    } else {
                        let err = [];
                        Object.values(res.response.data.errors).forEach(er => {
                            err = [...err, ...er];
                        });
                        this.errors = err;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>